import { FaqVatRefundsAnswer } from "../../../../src/components/faqItems";
import * as React from 'react';
export default {
  FaqVatRefundsAnswer,
  React
};